import { styled } from "../../styles/stitches.config"

export const Span = styled("span", {})
